import { setMyCommunityCurrView } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetCommunityPortalDetails } from "@/services";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COMM_USERS, COMMUNITY, PROPERTIES } from "./consts";
import { ROLE_BOM, roleMap } from "@/lib/utils";

const useCommunities = () => {
  const dispatch = useDispatch();
  const [globalFilter, setGlobalFilter] = useState("");

  const myCommunityCurrView = useSelector(
    (state: RootState) => state.currentData.myCommunityCurrView
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isBom = currentRole == ROLE_BOM;

  const { data: communityDetails, isLoading: isLoadingCommunity } =
    useGetCommunityPortalDetails({ community_id: communityData?.communityId, role: roleMap[currentRole] });

  const onViewMoreClick = () => {
    dispatch(
      setMyCommunityCurrView(myCommunityCurrView == COMMUNITY ? "" : COMMUNITY)
    );
  };

  const onShowProperty = () => {
    isBom ? dispatch(setMyCommunityCurrView(PROPERTIES)) : "";
  };

  const onShowUsers = () => {
    isBom ? dispatch(setMyCommunityCurrView(COMM_USERS)) : "";
  };

  return {
    globalFilter,
    setGlobalFilter,
    isLoadingCommunity,
    communityDetails,
    onViewMoreClick,
    onShowProperty,
    onShowUsers,
    myCommunityCurrView,
    isBom,
  };
};

export default useCommunities;
